import i18next from 'i18next';
import { RoleEnum } from 'types/RoleEnum';

export const companyRoleToString = (role: RoleEnum) => {
    switch (role) {
        case RoleEnum.ADMIN: return i18next.t('admin');
        case RoleEnum.BLOCKED: return i18next.t('blocked');
        case RoleEnum.USER: return i18next.t('user');
    }
}